import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-quiz-item',
  templateUrl: './quiz-item.component.html',
  styleUrls: ['./quiz-item.component.scss']
})
export class QuizItemComponent {
  @Output() answer = new EventEmitter<number>();
  @Input() question: any;
  @Input() checkedIndex: any;

  public onChange(answerId: number,event:any,type:any) {
    let data : any = {};
    if(type == "RADIO"){
      data.type = type;
      data.value = event.value;
      data.checked = event.checked;
    }else{
      data.type = type;
      data.value = event.source.value;
      data.checked = event.checked;
    }
    
    this.answer.emit(data);
  }
}
